declare namespace $ {

	export class $shm_hitalama_map_touch extends $mol_touch {
		Map_page( ): $shm_hitalama_map_page
		allow_wheel_zoom( ): boolean
		tool_active( ): boolean
		tool_cancel( ): any
	}
	
}

//# sourceMappingURL=touch.view.tree.d.ts.map